import React from 'react'
import Layout from './src/containers/Layout/Layout'
import store from 'src/rematch'
import wrapWithProvider from "./wrap-with-provider"

/**
 * This is a hack to suppress the React 18 warning about defaultProps
 * on function components. This is temporary and should be removed once
 * the ecosystem has caught up.
 */
export const onClientEntry = () => {
    if (process.env.NODE_ENV === 'development') {
        console.log('--- Suppressing defaultProps & deprecated findDOMNode warning ---')

        const originalError = console.error
        console.error = (...args) => {
            const defaultPropsWarning = /Support for defaultProps will be removed from function components/
            const findDOMNodeWarning = /findDOMNode is deprecated and will be removed in the next major release/
            if (typeof args[0] === 'string' && (defaultPropsWarning.test(args[0]) || findDOMNodeWarning.test(args[0]))) {
                return // Suppress the warning
            }
            originalError.apply(console, args) // Show all other errors
        }
    }
}

export const wrapPageElement = ({ element, props }) => (
    <Layout
        {...props}
        landingPage={props.path === '/'}
        onGrid={['/booking/lanes', '/booking/ref-and-sauna'].includes(
            props.path
        )}>
        {element}
    </Layout>
)

export const wrapRootElement = wrapWithProvider

export const onRouteUpdate = ({ location }) => {
    let newPathName = location.pathname.split('/')[1]
    if (newPathName.length === 0 || !['booking', 'me', 'admin'].includes(newPathName)) {
        newPathName = ''
    }
    // noinspection JSUnresolvedVariable
    store.dispatch.utils.updatePageTitle(newPathName)
}
